import React, { useRef, useState, useEffect } from "react";
// import { useIntl } from "react-intl";
// import { CustomButton } from "../../../lib/Buttons";
// import { RegularInput } from "../../../lib/Input";
// import UserTypeSelection from "./UserTypeSelection";
// import Header from "./Header";
// import SidePanel from "./SidePanel";
// import FooterLinks from "./FooterLinks";
// import RememberMeCheckbox from "./RememberMeCheckbox";
// import { useLocation } from "react-router-dom/";
// import LoginIcon from "../../../images/sign-in.svg?react";
// import Arrow from "../../../images/arrow.svg?react";
// import ReCAPTCHA from "react-google-recaptcha";

import SignIn from "~/images/log-in.svg?react";
import logo from "~/images/logos/watt-is.png";
import InputField from "~/lib/InputField";
import ReCAPTCHA from "react-google-recaptcha";
import DeviseLayout from "./DeviseLayout";
import useCsrfToken from "~/hooks/useCsrfToken";
import useDeviseFeedback from "~/hooks/useDeviseFeedback";

// import {
//   incorrectCredentialsToast,
//   loginMissingFieldsToast,
//   maximumAttemptsToast,
//   unconfirmedAccountToast,
//   unexpectedErrorToast,
//   noRecaptchaToast,
// } from "../../../lib/Toasts";

// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./ToastStyles.css";

// const identifyParticularInvalidFields = (data) => {
//   const invalidFields = [];

//   const nif = data.nif?.trim() || "";
//   const password = data.password || "";

//   if (nif.length == 0) {
//     invalidFields.push("nif");
//   }

//   if (password.length == 0) {
//     invalidFields.push("password");
//   }

//   return invalidFields;
// };

// const identifyEmpresarialInvalidFields = (data) => {
//   const invalidFields = [];

//   const email = data.email?.trim() || "";
//   const password = data.password || "";

//   if (email.length == 0) {
//     invalidFields.push("email");
//   }

//   if (password.length == 0) {
//     invalidFields.push("password");
//   }

//   return invalidFields;
// };

const LoginPage = () => {
  // const intl = useIntl();

  // const location = useLocation();

  // const query = new URLSearchParams(location.search);

  // const captchaRef = useRef(null);

  // const userType = query.get("type");

  // const [userData, setUserData] = useState({
  //   particular: {
  //     type: "particular",
  //     nif: "",
  //     password: "",
  //     remember_me: false,
  //   },
  //   empresarial: {
  //     type: "empresarial",
  //     email: "",
  //     password: "",
  //     remember_me: false,
  //   },
  // });

  // const [invalidFields, setInvalidFields] = useState([]);

  // const handleInputChange = (field, value) => {
  //   setUserData((prevData) => ({
  //     ...prevData,
  //     [userType]: {
  //       ...prevData[userType],
  //       [field]: value,
  //     },
  //   }));
  // };

  // const handleLogin = async () => {
  //   setInvalidFields([]);
  //   const csrfToken = document
  //     .querySelector("meta[name='csrf-token']")
  //     .getAttribute("content");

  //   const token = captchaRef.current.getValue();
  //   userData[userType].captcha_token = token;

  //   const loginData = userData[userType];

  //   const newInvalidFields =
  //     userType == "particular"
  //       ? identifyParticularInvalidFields(loginData)
  //       : identifyEmpresarialInvalidFields(loginData);

  //   if (newInvalidFields.length != 0) {
  //     setInvalidFields(newInvalidFields);

  //     toast.error(loginMissingFieldsToast, {
  //       className: "register-toast",
  //       progressClassName: "custom-progress-bar",
  //       icon: false,
  //     });

  //     return;
  //   }

  //   try {
  //     const response = await fetch("/users/sign_in", {
  //       method: "POST",
  //       credentials: "include",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "X-CSRF-Token": csrfToken,
  //       },
  //       body: JSON.stringify(loginData),
  //     });

  //     if (!response.ok) {
  //       const data = await response.json();

  //       if (data.error.type == "locked-account") {
  //         toast.error(maximumAttemptsToast, {
  //           className: "register-toast",
  //           progressClassName: "custom-progress-bar",
  //           icon: false,
  //         });
  //       } else if (data.error.type == "unconfirmed-account") {
  //         toast.error(unconfirmedAccountToast, {
  //           className: "register-toast",
  //           progressClassName: "custom-progress-bar",
  //           icon: false,
  //         });
  //       } else if (data.error.type == "unauthorized") {
  //         toast.error(incorrectCredentialsToast, {
  //           className: "alert-toast",
  //           progressClassName: "custom-progress-bar",
  //           icon: false,
  //         });
  //       } else if (data.error.type == "captcha_error") {
  //         toast.error(noRecaptchaToast, {
  //           className: "alert-toast",
  //           progressClassName: "custom-progress-bar",
  //           icon: false,
  //         });
  //       } else {
  //         toast.error(unexpectedErrorToast, {
  //           className: "alert-toast",
  //           progressClassName: "custom-progress-bar",
  //           icon: false,
  //         });
  //       }

  //       return;
  //     }

  //     window.location.href = "/consumptions";
  //   } catch (error) {
  //     toast.error(unexpectedErrorToast, {
  //       className: "alert-toast",
  //       progressClassName: "custom-progress-bar",
  //       icon: false,
  //     });
  //   } finally {
  //     captchaRef.current.reset();
  //   }
  // };

  useDeviseFeedback();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [captchaError, setCaptchaError] = useState(false);

  const [tip, setTip] = useState(null);
  const [tipLoading, setTipLoading] = useState(false);

  const csrfToken = useCsrfToken();

  const captchaRef = useRef(null);

  /* useEffect(() => {
    const fetchTip = async () => {
      try {
        const response = await fetch("/api/v1/login_message");

        if (!response.ok || response.status === 204) {
          setTip(null);
          return;
        }

        const data = await response.json();
        setTip(data);
      } catch (err) {
        console.error("Erro ao obter dica de login:", err);
        setTip(null);
      } finally {
        setTipLoading(false);
      }
    };

    fetchTip();
  }, []); */

  const tipTitle = tip?.title || "Aproveite os ciclos horários da sua tarifa";

  const tipText =
    tip?.text ||
    "Se tiver uma tarifa bi ou tri-horária, prefira os períodos em vazio para utilizar eletrodomésticos de elevado consumo como máquinas de lavar/secar, bomba da piscina ou termoacumulador/bomba de calor para aquecimento de águas sanitárias.";

  const handleSubmit = (e) => {
    e.preventDefault();

    const token = captchaRef.current?.getValue();

    if (!token) {
      setCaptchaError(true);
      return;
    }

    setCaptchaError(false);

    const form = e.target;

    let hiddenInput = form.querySelector("input[name='captcha_token']");

    if (!hiddenInput) {
      hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = "captcha_token";
      form.appendChild(hiddenInput);
    }

    hiddenInput.value = token;

    form.submit();
  };

  return (
    <DeviseLayout
      tipTitle={tipLoading ? "A carregar dica..." : tipTitle}
      tipText={
        tipLoading ? "A preparar uma dica eficiente para si..." : tipText
      }
    >
      <form
        action="/users/sign_in"
        method="post"
        onSubmit={handleSubmit}
        className="flex flex-col gap-3 lg:gap-6"
      >
        <input
          type="hidden"
          value={csrfToken}
          name="authenticity_token"
        />

        <div className="flex flex-col items-center mb-2 lg:mb-4">
          <img
            src={logo}
            alt="Watt-IS"
            className="w-24 lg:w-32 h-auto mb-2 lg:mb-4"
          />
          <h2 className="text-lg lg:text-4xl font-normal text-center text-text-black leading-tight">
            Qual a sua energia para hoje?
          </h2>
        </div>

        <div className="flex flex-col gap-2 mx-4 lg:mx-20">
          <InputField
            id="email"
            label="E-mail"
            model={email}
            name="user[email]"
            onChange={setEmail}
            labelStyle="text-xs lg:text-sm font-medium text-text-soft-gray"
            inputStyle="focus:ring-2 focus:ring-text-soft-gray focus:outline-0 px-4 py-2 lg:py-3 border border-gray-400 bg-gray-100 rounded-2xl text-sm lg:text-base"
          />
        </div>

        <div className="flex flex-col gap-2 mx-4 lg:mx-20">
          <InputField
            id="password"
            label="Palavra-passe"
            type="password"
            model={password}
            name="user[password]"
            onChange={setPassword}
            labelStyle="text-xs lg:text-sm font-medium text-text-soft-gray"
            inputStyle="focus:ring-2 focus:ring-text-soft-gray focus:outline-0 px-4 py-2 lg:py-3 border border-gray-400 bg-gray-100 rounded-2xl text-sm lg:text-base"
          />
        </div>

        <div
          className={`flex flex-col items-center justify-center scale-75 lg:scale-100 my-2`}
        >
          <div
            className={`rounded-lg transition-all ${
              captchaError
                ? "border-2 border-red-500"
                : "border-2 border-transparent p-1"
            }`}
          >
            <ReCAPTCHA
              ref={captchaRef}
              sitekey={import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY}
              onChange={() => setCaptchaError(false)}
            />
          </div>

          {captchaError && (
            <p className="text-red-500 text-xs mt-2 text-center transition-opacity duration-200">
              Por favor valide o reCAPTCHA antes de entrar.
            </p>
          )}
        </div>

        <button
          className="transition-all flex items-center justify-center gap-2 py-3 lg:py-4 rounded-full bg-btn-tertiary hover:bg-btn-primary text-base lg:text-xl text-white cursor-pointer mx-10 lg:mx-36 mt-2"
          type="submit"
        >
          Entrar
          <SignIn className="w-auto lg:h-fit" />
        </button>

        <hr className="h-[1px] bg-black border-0 my-4 mx-8" />

        <div className="flex flex-col items-center gap-1 lg:gap-3 text-sm lg:text-base">
          <a
            href="/users/password/new"
            className="text-btn-tertiary hover:text-btn-primary font-semibold text-center"
          >
            Esqueceu-se da palavra-passe?
          </a>
          <p className="text-text-black font-medium text-center">
            Novo utilizador?{" "}
            <a
              href="/users/sign_up"
              className="text-btn-tertiary hover:text-btn-primary font-semibold"
            >
              Registe-se aqui!
            </a>
          </p>
        </div>
      </form>
    </DeviseLayout>
  );
};

export default LoginPage;
